exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title_box[data-v-03baa96c]{padding:10px 10px 16px}.auth_box[data-v-03baa96c]{padding:0 10px 16px}.auth_box .link[data-v-03baa96c]{margin-left:10px}\n", ""]);

// exports
